//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogContent from './dialogContent.vue';
import viewportMixin from '@/mixins/viewport.mixin';

export default {
  components: { DialogContent },
  mixins: [viewportMixin],
  computed: {
    display: {
      get() {
        return this.$store.state.sale.choiceDialog;
      },
      set(payload) {
        this.$store.commit('sale/setChoiceDialog', payload);
      },
    },
  },
};
